//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { useQuery } from '@tanstack/react-query';

import { getRightsHistoricalUrls } from '@apis/rights-management/rightsManagementApi';
import { HistoricalUrlsResponse } from '@apis/rights-management/rightsManagementApiModels';
import { QueryKeyConstants } from '@queries/QueryKeyConstants';
import { FIVE_MINUTES_STALE_TIME } from '@queries/QueryOptionsConstants';

export const useRightsHistoricalUrlsQuery = <TData = HistoricalUrlsResponse>(
  select?: (data: HistoricalUrlsResponse) => TData,
  enabled?: boolean,
) =>
  useQuery({
    enabled,
    queryKey: [
      QueryKeyConstants.UniversalImageActions,
      QueryKeyConstants.UniversalImageActionsRights,
      QueryKeyConstants.UniversalImageActionsRightsHistoricalUrls,
    ],
    queryFn: async ({ signal }) => getRightsHistoricalUrls({ signal }),
    select,
    staleTime: FIVE_MINUTES_STALE_TIME,
  });

export function hasNoHistoricalUrls(historicalUrls: HistoricalUrlsResponse) {
  return historicalUrls.length < 1;
}
